import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Invite a member to iknowa platform", -1)
const _hoisted_3 = { class: "modal__content !tw-border-none" }
const _hoisted_4 = { class: "tw-flex tw-gap-2 tw-items-center tw-w-full tw-bg-[rgba(75,75,255,0.1)] tw-p-4 tw-box-border tw-rounded-[4px]" }
const _hoisted_5 = { class: "modal__inner__content" }
const _hoisted_6 = { class: "input_field email_address" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Email Addresses", -1)
const _hoisted_8 = { class: "input_field invite_wrapper" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Invite As", -1)
const _hoisted_10 = { class: "input_field tags_wrapper" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Tags", -1)
const _hoisted_12 = { class: "input_field message_wrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Message (optional):", -1)
const _hoisted_14 = { class: "modal__footer tw-pt-4 tw-border-t-dashed-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvitationSuccessComponent = _resolveComponent("InvitationSuccessComponent")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Text = _resolveComponent("Text")!
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return ($setup.isShowInvitationsSentModal)
    ? (_openBlock(), _createBlock(_component_InvitationSuccessComponent, {
        key: 0,
        onOnClose: $setup.onClickCloseButton,
        members: $setup.form.members
      }, null, 8, ["onOnClose", "members"]))
    : (_openBlock(), _createBlock(_component_CommonDialog, {
        key: 1,
        isShowHeader: false,
        isShowBackButton: false,
        className: ['add_team_member_dialog !tw-z-[999]'],
        width: "968px"
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickCloseButton(false, $event)))
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Each added member costs £9.99/month.")
                ]),
                _: 1
              }),
              _createVNode(_component_ToolTip, {
                direction: "bottom",
                iconColor: "rgba(12, 15, 74, 0.3)",
                icon: "mdi-information",
                description: "For every new member you add, your monthly charge will increase by £9.99. For example, adding 3 members will raise your bill by £29.97 (£9.99 x 3). The charge is recurring each month for every active member. You can remove members at any time, and your bill will adjust accordingly."
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_form, {
                ref: "emailFormRef",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                class: "tw-w-full"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.members, (member, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "tw-w-full invite_members_form"
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_v_text_field, {
                          type: "email",
                          density: "compact",
                          modelValue: member.email,
                          "onUpdate:modelValue": ($event: any) => ((member.email) = $event),
                          rules: $setup.validation.email,
                          variant: "outlined",
                          class: "c-input",
                          placeholder: "Email address"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_v_select, {
                          placeholder: "Select",
                          modelValue: member.role,
                          "onUpdate:modelValue": ($event: any) => ((member.role) = $event),
                          rules: $setup.validation.role,
                          items: ['Admin', 'Editor', 'Viewer'],
                          variant: "outlined",
                          class: "c-select"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_v_select, {
                          class: "c-select",
                          modelValue: member.tags,
                          "onUpdate:modelValue": ($event: any) => ((member.tags) = $event),
                          items: $setup.Tags,
                          placeholder: "Select Tags",
                          multiple: "",
                          variant: "outlined",
                          "menu-props": { contentClass: 'tags_dropdown' }
                        }, {
                          "prepend-item": _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              title: "Select All",
                              onClick: ($event: any) => ($setup.toggle(member))
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_checkbox_btn, {
                                  color: 
                            $setup.likesSomeTag(member) ? 'indigo-darken-4' : undefined
                          ,
                                  indeterminate: 
                            $setup.likesSomeTag(member) && !$setup.likesAllTags(member)
                          ,
                                  "model-value": $setup.likesAllTags(member)
                                }, null, 8, ["color", "indeterminate", "model-value"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_divider, { class: "mt-2" })
                          ]),
                          "append-item": _withCtx(() => [
                            _createVNode(_component_v_divider, { class: "mb-2" }),
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: $setup.customTag,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customTag) = $event)),
                                  placeholder: "Add custom tag",
                                  variant: "outlined"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Button, {
                                  variant: "accent",
                                  label: "Add",
                                  class: "!tw-w-auto",
                                  onClick: ($event: any) => ($setup.addCustomTag(member))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "items"])
                      ]),
                      ($setup.form.members.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "mdi-close",
                            onClick: ($event: any) => ($setup.onRemoveEmail(index)),
                            class: "remove_btn",
                            variant: "plain"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createVNode(_component_Button, {
                    variant: "accent",
                    label: "+ADD",
                    class: "!tw-w-[100px]",
                    onClick: $setup.onAddEmail
                  }, null, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_v_textarea, {
                      modelValue: $setup.memberMessage,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.memberMessage) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              variant: "secondary",
              label: "cancel",
              class: "!tw-w-auto",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.onClickCloseButton(false, $event)))
            }),
            _createVNode(_component_Button, {
              variant: "accent",
              label: "send invitation",
              class: "!tw-w-auto",
              onClick: $setup.onSendInvitation,
              isLoading: $setup.isShowLoadingSendInvitation
            }, null, 8, ["onClick", "isLoading"])
          ])
        ]),
        _: 1
      }))
}